import { useQueryClient } from '@tanstack/react-query';
import { NotificationManager } from 'react-notifications';
import { useApiMutation } from '@/hooks/api/useApiMutation';
import { useGetQuery } from '@/hooks/api/useGetQuery';
import { queryKeys } from '../query-keys';

export function usePerformersQuery() {
  return useGetQuery(() => '/admin/performers', {}, queryKeys.performers(), {});
}

export function usePerformerTypesQuery() {
  return useGetQuery(
    () => '/admin/performer-types',
    {},
    queryKeys.performerTypes(),
    {},
  );
}

export function useSavePerformerMutation() {
  const queryClient = useQueryClient();
  return useApiMutation(
    (performer) => '/admin/performer',
    'post',
    {},
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: queryKeys.performers() });
        NotificationManager.success('Performer saved', '', 3000);
      },
      onError: () => {
        NotificationManager.error('Performer could not be saved', '', 3000);
      },
    },
  );
}
